"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _reactJss = require("react-jss");
var _splitCommonFromProps4 = _interopRequireDefault(require("../../../utils/splitCommonFromProps"));
var _initVars = _interopRequireDefault(require("../../../utils/vars/initVars"));
var _excluded = ["children", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var tableDataCommon = ["background", "textAlign", "verticalAlign"];
var tableDataVars = (0, _initVars.default)({
  applied: tableDataCommon
});
var TableData = function TableData(props) {
  var _splitCommonFromProps = (0, _splitCommonFromProps4.default)(props, tableDataCommon),
    _splitCommonFromProps2 = _slicedToArray(_splitCommonFromProps, 2),
    common = _splitCommonFromProps2[0],
    _splitCommonFromProps3 = _splitCommonFromProps2[1],
    children = _splitCommonFromProps3.children,
    className = _splitCommonFromProps3.className,
    otherProps = _objectWithoutProperties(_splitCommonFromProps3, _excluded);
  var classes = useStyle(tableDataVars.useVars(common));
  return /*#__PURE__*/_react.default.createElement("td", _extends({
    className: (0, _classnames.default)(classes.root, classes.variables, className)
  }, otherProps), children);
};
var style = function style(theme) {
  return {
    variables: tableDataVars.styles,
    root: {
      borderWidth: 1,
      borderColor: theme.colors.baseContrast040,
      padding: [theme.spacing.base, theme.spacing.base * 2],
      color: theme.colors.baseContrast085,
      verticalAlign: "top"
    }
  };
};
var useStyle = (0, _reactJss.createUseStyles)(style);
TableData.displayName = "TableData";
var _default = exports.default = TableData;